export default class PageScroll {
    constructor() {
        this.scrollReveal()
    }

    //板块缓动动画
    scrollReveal() {
        window.sr = ScrollReveal({
            origin: 'bottom',
            scale: 1,
            distance: '50px',
            easing: 'ease-in-out',
            nav_mobile: false,
            mobile: false,
            viewOffset: {
                top: 30,
                right: 0,
                bottom: 30,
                left: 0
            },
        })

        let array = '.share, .app-play, #recommends, .kingdom-songs, .create-songs-list, .classify-songs, .local-abouchement, .img-box,  .mobile-model, .wonderful-movie, .mobile-small,.carousel-box, .online-talk .section-title,.online-talk .description, .question-item, .app-rwm, .footer-top, .footer-bottom'
        sr.reveal(array, {
            duration: 600,
            delay: 320,
        });

        //第一屏图片展示动画
        $('.recommend-item').map((i, el) => {
            sr.reveal($(el), {
                duration: 600,
                delay: 120 * i,
                distance: '3em'
            });
        })

        //首屏其他动画
        sr.reveal('.title', {
            origin: 'right',
            distance: '3em'
        });
        sr.reveal('.sub-title', {
            origin: 'left',
            distance: '3em'
        });

        //常见问题 列表动画
        $('.question-item').map((i, el) => {
            sr.reveal($(el), {
                duration: 600,
                delay: 80 * i,
                distance: '3em'
            });
        })
        // 各板块大标题及描述动画
        sr.reveal('.feature .section-title', {
            duration: 600,
            origin: 'right',
            delay: 800
        });

        sr.reveal('.feature .description', {
            duration: 600,
            origin: 'right',
            delay: 1000
        });

        sr.reveal('.container.align-center .section-title', {
            duration: 600
        });

        sr.reveal('.container.align-center .description, .ratio-online-talk-img ', {
            duration: 600,
            delay: 200
        });

        //板块4 凸起部分
        sr.reveal('.cover-wrapper', {
            delay: 800,
            scale: 0.85
        });


        //手机动画
        sr.reveal('.mobile', {
            duration: 600,
            delay: 440
        });


    }
}